import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/globals/globals';
import { CostingToolFilterValue } from 'src/app/shared/models/data/costingToolFilterValue.model';
import { MasterDataVers, MasterDataVersion } from 'src/app/shared/models/data/masterDataVersion.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { CustomIcoCol } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { GridColumn, GridConfiguration } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { TeiasoftModalReturnObject } from 'src/app/shared/teiasoft-bucket/teiasoft-modal/teiasoft-modal.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import { DatePipe } from '@angular/common';
import { Enquiry, EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';
import { CostingToolDimType, CostingToolRecord, CostingToolRecordsResponse } from 'src/app/shared/models/data/costingToolRecords.model';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { ItemParametersValues, UomsType } from 'src/app/shared/models/data/itemParametersValues.model';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { catchError, forkJoin, of } from 'rxjs';
import _ from 'lodash';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';
declare var $: any;

@Component({
  selector: 'app-costing-tool',
  templateUrl: './costing-tool.component.html',
  styleUrls: ['./costing-tool.component.scss']
})
export class CostingToolComponent implements OnInit {
  enquiryNo: string = '';
  itemNo: string = '';
  origin: string = ''; // 'edit-enquiry' || 'record-id'
  title: string = ""; // Can be: '' for free search, 'edit-enquiry' or 'enquiry-book'
  filtersOptionReady = false;
  costingToolFilterValue: CostingToolFilterValue = new CostingToolFilterValue();
  itemParameterValues: ItemParametersValues = new ItemParametersValues();
  roundDigitsForItemForm: RoundDigit[] = new Array();
  rmGradeOptionList: SelectOption[] = new Array();
  alloyOptionList: SelectOption[] = new Array();
  processOptionList: SelectOption[] = new Array();
  utOptionList: SelectOption[] = new Array();
  hydroOptionList: SelectOption[] = new Array();
  lgTypeOptionList: SelectOption[] = new Array();
  htHotOptionList: SelectOption[] = new Array();
  htColdOptionList: SelectOption[] = new Array();
  htAddOptionList: SelectOption[] = new Array();
  unitSystemOptionList: SelectOption[] = new Array();
  currencyOptionList: SelectOption[] = new Array();

  plantOptionList: SelectOption[] = new Array();
  endsConditionOptionList: SelectOption[] = new Array();
  testConditionOptionList: SelectOption[] = new Array();
  uBendOptionList: SelectOption[] = new Array();
  sqlOptionList: SelectOption[] = new Array();

  @Input() inputEnquiryNo?: string;
  @Input() inpuItem?: EnquiryHeaderItem;
  @Input() inputOrigin?: string;
  @Input() inputUseNearestMatch?: boolean;
  @Input() inputCostsSourceCostingToolRecordId?: number | null;
  @Input() inputCostsSourceCostingToolVersionId?: number | null;
  @Input() inputUnitSystem?: string | null;
  @Input() inputCurrency?: string | null;

  @Output() onBackClick: EventEmitter<any> = new EventEmitter();


  buttonsList: TTButton[] = new Array();
  buttonsListBack: TTButton[] = new Array();
  showAdditionalSelections: boolean = false;

  // Values
  rawMaterialGrade: string | null = null;
  asIncluded: boolean | null = true;
  od: number | null = null;
  wt: number | null = null;
  id: number | null = null;
  insideDiameter: number | null = null;
  process: string | null = null;
  ut: boolean | null = null;
  hydro: boolean | null = null;
  lengthType: string | null = null;
  htHot: boolean | null = null;
  htCold: boolean | null = null;
  htAdd: boolean | null = null;
  clearValue: boolean = false;
  plant: string | null = null;
  endsCondition: string | null = null;
  testCondition: string | null = null;
  lengthMin: number | null = null;
  lengthMax: number | null = null;
  uBent: boolean | null = null;
  sql: string | null = null;
  unitSystem: string | null = null;
  currency: string | null = null;

  resultDataset: CostingToolRecord[] = new Array();
  columnsToShowResult: string[] = ['plant', 'process', 'fullCostPerWeight', 'fullCostPerLength', 'materialPricePerWeight',
    'weightPerLength', 'hollowOd', 'hollowWt', 'hollowSupplier', 'bar', 'yield', 'nrPilgSteps', 'summary'];

  columnsToHighlightBigResult: string[] = ['fullCostPerWeight'];
  columnsToHighlightResult: string[] = ['fullCostPerLength'];
  customIcoColsResult: CustomIcoCol[] = new Array();


  nearestDataset: CostingToolRecord[] = new Array();
  columnsToShowNearest: string[] = this.columnsToShowResult;

  columnsToHighlightBigNearest: string[] = ['fullCostPerWeight'];
  columnsToHighlightNearest: string[] = ['fullCostPerLength'];
  customIcoColsNearest: CustomIcoCol[] = new Array();

  readonly resultGridName: string = 'CostingToolResult';
  readonly nearestGridName: string = 'CostingToolNearest';
  resultGridConfiguration: GridConfiguration = new GridConfiguration();
  nearestGridConfiguration: GridConfiguration = new GridConfiguration();

  selectedCostingToolId: number = -1;
  isSubmit: boolean = false;

  odRequired: boolean = true;
  wtRequired: boolean = true;
  idRequired: boolean = true;

  masterDataVersions: MasterDataVers[] = new Array();
  versionsOptionList: SelectOption[] = new Array();
  selectedVersionId: number | null = null;
  versionId: number | null = null;
  selectedVersionTimestamp?: number;
  costsSourceCostingToolRecordId: number | null = null;
  versionDisabled: boolean = false;
  item?: EnquiryHeaderItem;
  useNearestMatch: boolean = false;
  contextSelectionDisabled: boolean = false;

  @ViewChild('costingToolHeader', { static: true }) costingToolHeader!: TemplateRef<any>;

  private readonly headerUomByColumn: { [key: string]: string } = {
    fullCostPerWeight: 'fullCostPerWeightUom',
    fullCostPerLength: 'fullCostPerLengthUom',
    materialPricePerWeight: 'materialPricePerWeightUoM',
    weightPerLength: 'weightPerLengthUom',
    lengthMin: 'lengthUom',
    lengthMax: 'lengthUom'
  };

  customHeaderRenderers = {
    fullCostPerWeight: () => ({ template: this.costingToolHeader, context: { column: 'fullCostPerWeight' } }),
    fullCostPerLength: () => ({ template: this.costingToolHeader, context: { column: 'fullCostPerLength' } }),
    materialPricePerWeight: () => ({ template: this.costingToolHeader, context: { column: 'materialPricePerWeight' } }),
    weightPerLength: () => ({ template: this.costingToolHeader, context: { column: 'weightPerLength' } })
  };

  constructor(private activatedRoute: ActivatedRoute, private translate: TranslateService, private teiasoftLoader: TeiasoftLoaderService,
    private beService: BackendService, public globals: Globals, private router: Router, private teiasoftModalService: TeiasoftModalService,
    private teiasoftToaster: TeiasoftToasterService, private utils: UtilsService, private datePipe: DatePipe) {

    this.initializeGridConfigurations();
    this.activatedRoute.queryParams.subscribe(params => {

      this.title = this.translate.instant('costingTool.title');
      this.buildButtonsList();
      this.loadOriginItemProperties();
      if (params && params["costsSourceCostingToolVersionId"] && params["costsSourceCostingToolVersionId"]) {
        this.selectedVersionId = parseInt(params["costsSourceCostingToolVersionId"]);
        this.versionId = parseInt(params["costsSourceCostingToolVersionId"]);
        this.costsSourceCostingToolRecordId = parseInt(params["costsSourceCostingToolRecordId"]);
        this.origin = params["origin"];
        this.enquiryNo = params["enquiryNo"];
        this.itemNo = params["itemNo"];
        this.useNearestMatch = params["useNearestMatch"] === 'true' ? true : false;
        this.versionDisabled = true;
        this.syncFilterToolbarState();
        this.getMasterDataVersions();
        this.getCostingToolRecordsById();
      } else if (params && params["costsSourceCostingToolVersionId"] == undefined && params["costsSourceCostingToolVersionId"] == undefined
        && params["enquiryNo"] && params["itemNo"] && params["origin"]) {
        this.enquiryNo = params["enquiryNo"];
        this.itemNo = params["itemNo"];
        this.origin = params["origin"];
        this.useNearestMatch = params["useNearestMatch"] === 'true' ? true : false;
        this.selectedVersionId = null;
        this.versionId = null;
        this.buildCustomIconGrid();
      }
      else {
        this.getMasterDataVersions();
      }

      this.getCostingToolFiltersValues();
    });
  }

  ngOnInit(): void {
    if (this.inputEnquiryNo) {
      this.enquiryNo = this.inputEnquiryNo;
    }

    if (this.inpuItem) {
      this.itemNo = this.inpuItem.itemNo!;
      this.item = this.inpuItem;
    }

    if (this.inputOrigin) {
      this.origin = this.inputOrigin;
    }

    if (this.inputUseNearestMatch !== undefined) {
      this.useNearestMatch = this.inputUseNearestMatch;
    }

    if (this.inputCostsSourceCostingToolVersionId != null && this.inputCostsSourceCostingToolRecordId != null) {
      this.applyInputUnitSystemAndCurrency();
      this.selectedVersionId = this.inputCostsSourceCostingToolVersionId;
      this.versionId = this.inputCostsSourceCostingToolVersionId;
      this.costsSourceCostingToolRecordId = this.inputCostsSourceCostingToolRecordId;
      this.versionDisabled = true;
      this.origin = this.inputOrigin || 'record-id';
      this.syncFilterToolbarState();
      this.getMasterDataVersions();
      this.getCostingToolRecordsById();
      return;
    }

    if (this.inputEnquiryNo && this.inpuItem) {
      this.applyInputUnitSystemAndCurrency();
      this.selectedVersionId = null;
      this.versionId = null;
      this.buildCustomIconGrid();
    }
  }

  private applyInputUnitSystemAndCurrency() {
    if (this.inputUnitSystem) this.unitSystem = this.inputUnitSystem;
    if (this.inputCurrency) this.currency = this.inputCurrency;
    this.contextSelectionDisabled = !!this.inputEnquiryNo && !!this.inpuItem;
  }

  loadOriginItemProperties() {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.item = navigation.extras.state['item'];
    }
  }

  onKeyDown($event: KeyboardEvent) {
    if ($event.key == 'Enter' && !this.buttonsList[2].disabled) {
      this.getCostingToolRecords(true);
    }
  }

  /* METHODS */
  buildButtonsList() {
    this.buttonsList = new Array();
    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-angle-down';
    _item.id = 0;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "addAdditional";
    _item.action = "addAttitional";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-eraser';
    _item.id = 2;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* SUBMIT */
    _item = new TTButton();
    _item.disabled = true;
    _item.icon = 'fal fa-search';
    _item.id = 3;
    _item.size = "";
    _item.text = "submit";
    _item.tooltip = "submit";
    _item.action = "submit";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    this.buttonsListBack = new Array();
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fas fa-arrow-left';
    _item.id = 0;
    _item.size = "";
    _item.text = "back";
    _item.tooltip = "back";
    _item.action = "back";
    _item.type = "";
    _item.state = '';
    this.buttonsListBack.push(_item);
    this.syncFilterToolbarState();
  }

  isRecordViewMode(): boolean {
    return this.origin == 'record-id' && this.costsSourceCostingToolRecordId != null;
  }

  filtersDisabled(): boolean {
    return this.isRecordViewMode() || this.isOlderVersionSelected();
  }

  private syncFilterToolbarState() {
    if (!this.buttonsList || this.buttonsList.length == 0) return;
    if (!this.isRecordViewMode()) return;

    for (const button of this.buttonsList) {
      button.disabled = true;
    }
  }

  buildCustomIconGrid() {
    this.customIcoColsResult = new Array();
    let _item: CustomIcoCol = new CustomIcoCol();
    _item.action = 'selectThis';
    _item.icon = 'fas fa-external-link';
    _item.label = "selectThis";
    this.customIcoColsResult.push(_item);

    this.customIcoColsNearest = new Array();
    _item = new CustomIcoCol();
    _item.action = "selectThis";
    _item.icon = 'fas fa-external-link';
    _item.label = "selectThis";
    this.customIcoColsNearest.push(_item);
  }
  private initializeGridConfigurations(): void {
    this.resultGridConfiguration = this.ensureGridConfiguration(this.resultGridName, this.columnsToShowResult.filter(col => col !== 'summary'));
    this.nearestGridConfiguration = this.ensureGridConfiguration(this.nearestGridName, this.columnsToShowNearest.filter(col => col !== 'summary'));
  }

  private ensureGridConfiguration(name: string, columns: string[]): GridConfiguration {
    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfiguration = userConfiguration.gridsConfigurations?.find(cfg => (cfg.name ?? '').toLowerCase() === name.toLowerCase());

    const gridConfiguration = savedConfiguration ? _.cloneDeep(savedConfiguration) : new GridConfiguration();
    gridConfiguration.name = name;
    gridConfiguration.gridColumns = this.mergeGridColumns(columns, gridConfiguration.gridColumns ?? []);

    this.utils.upsertGridConfiguration(gridConfiguration);
    return gridConfiguration;
  }

  private mergeGridColumns(columns: string[], existingColumns: GridColumn[]): GridColumn[] {
    const columnMap = new Map(existingColumns.map(column => [(column.name ?? '').toLowerCase(), column]));

    return columns.map((column, index) => {
      const existingColumn = columnMap.get(column.toLowerCase());
      const gridColumn = existingColumn ? Object.assign(new GridColumn(), existingColumn) : new GridColumn();

      gridColumn.id = existingColumn?.id ?? index;
      gridColumn.position = existingColumn?.position ?? index + 1;
      gridColumn.name = column;
      gridColumn.visible = existingColumn?.visible ?? true;
      gridColumn.width = existingColumn?.width ?? 175;

      return gridColumn;
    });
  }

  getMasterDataVersions() {
    this.beService.getMasterDataVersions('CostingTool').subscribe(res => {
      if (res && res.masterDataVersions!) {
        this.masterDataVersions = new Array();
        this.masterDataVersions = res.masterDataVersions!.sort((a: MasterDataVers, b: MasterDataVers) => { return b.id! - a.id! });
        this.versionsOptionList = new Array();
        for (var x = 0; x < this.masterDataVersions.length; x++) {
          let _item: SelectOption = new SelectOption();
          _item.value = this.masterDataVersions[x].id!;
          _item.text = this.masterDataVersions[x].isCurrent ? this.translate.instant("commons.currentVersion") : this.datePipe.transform(this.masterDataVersions[x].importTimestamp!, this.globals.dateFormat);
          _item.text += " - " + this.masterDataVersions[x].versionInfo!; // MQF-478
          this.versionsOptionList.push(_item);
        }
        if (this.selectedVersionId == null) {
          this.selectedVersionId = this.masterDataVersions.filter(x => x.isCurrent == true)[0].id!;
          this.versionId = null; // Quella che mado la BE per la Current deve essere sempre null
        }
      }
    });
  }

  getCostingToolFiltersValues() {
    this.teiasoftLoader.start();
    forkJoin({
      filters: this.beService.getCostingToolFiltersValues(),
      itemParameters: this.beService.getItemParametersValues().pipe(catchError(() => of(new ItemParametersValues()))),
      roundDigits: this.utils.getRoundDigits().pipe(catchError(() => of([] as RoundDigit[])))
    }).subscribe(({ filters, itemParameters, roundDigits }) => {
      this.costingToolFilterValue = new CostingToolFilterValue();
      this.costingToolFilterValue = filters;
      this.itemParameterValues = itemParameters;
      this.roundDigitsForItemForm = roundDigits.filter(x => x.section == 'ItemForm' && x.api == 'UpdateEnquiryItems');
      this.buildOptionsList();
      this.applyInputUnitSystemAndCurrency();
      // Se arrivo da edit enquiry per "ToBeEvaluated" prefillo i filtri
      if (this.origin == 'edit-enquiry')
        this.getCostingToolFiltersValuesByItem();
      else if (!this.contextSelectionDisabled)
        this.getUnitSystemAndCurrencyByUser();
      else {
        this.teiasoftLoader.stop();
        this.asIncluded = true;
      }
    });
  }

  getUnitSystemAndCurrencyByUser() {
    this.beService.getUnitSystemAndCurrencyByUser().subscribe({
      next: res => {
        this.unitSystem = res.unitSystem ?? this.unitSystem ?? this.unitSystemOptionList[0]?.value ?? null;
        this.currency = res.currency ?? this.currency ?? this.currencyOptionList[0]?.value ?? null;
      },
      error: () => {
        this.unitSystem = this.unitSystem ?? this.unitSystemOptionList[0]?.value ?? null;
        this.currency = this.currency ?? this.currencyOptionList[0]?.value ?? null;
      },
      complete: () => {
        this.teiasoftLoader.stop();
        this.asIncluded = true;
      }
    });
  }

  getCostingToolFiltersValuesByItem() {
    this.beService.getCostingToolFiltersValuesByItem(this.enquiryNo, this.itemNo, this.useNearestMatch).subscribe(res => {
      this.unitSystem = res.unitSystem ?? this.unitSystem;
      this.currency = res.currency ?? this.currency;
      this.contextSelectionDisabled = true;
      this.rawMaterialGrade = res.rawMaterialGrade!;
      this.asIncluded = true;
      this.od = res.od!;
      this.wt = res.wt!;
      this.id = res.insideDiameter!;
      this.process = res.process!;
      this.ut = res.ut!;
      this.hydro = res.hydro!;
      this.lengthType = res.lengthType!;
      this.htHot = res.htHot!;
      this.htCold = res.htCold!;
      this.htAdd = res.htAdd!;
      this.plant = res.plant!;
      this.endsCondition = res.endsCondition!;
      this.testCondition = res.testCondition!;
      this.lengthMin = res.lengthMin!;
      this.lengthMax = res.lengthMax!;
      this.uBent = (res as any).uBend ?? (res as any).uBent ?? (res as any).bending ?? null;
      this.sql = (res as any).sql ?? (res as any).specQualLevel ?? null;

      // MQF-477
      if (this.process != null || this.ut != null || this.hydro != null || this.lengthType != null || this.htHot != null || this.htCold != null || this.htAdd != null || this.uBent != null || this.sql != null) {
        $('.row-additional').fadeIn(250);
        this.showAdditionalSelections = true;
        this.buttonsList[0].action = "closeAdditional";
        this.buttonsList[0].tooltip = "closeAdditional";
        this.buttonsList[0].icon = "fal fa-angle-up";
      }
      // END MQF-477

      if (this.rawMaterialGrade != null && this.asIncluded != null) {
        this.buttonsList[2].disabled = false;
        this.getCostingToolRecords(false);
      } else {
        this.teiasoftLoader.stop();
      }
    });
  }

  buildOptionsList() {
    let _item: SelectOption = new SelectOption();

    this.unitSystemOptionList = new Array();
    for (const unitSystem of (this.costingToolFilterValue.unitSystem ?? [])) {
      _item = new SelectOption();
      _item.value = unitSystem;
      _item.text = unitSystem;
      this.unitSystemOptionList.push(_item);
    }

    this.currencyOptionList = new Array();
    for (const currency of (this.costingToolFilterValue.currency ?? [])) {
      _item = new SelectOption();
      _item.value = currency;
      _item.text = currency;
      this.currencyOptionList.push(_item);
    }

    // RM Grade
    this.rmGradeOptionList = new Array();
    for (var x = 0; x < this.costingToolFilterValue.rawMaterialGrade!.length; x++) {
      _item = new SelectOption();
      _item.value = this.costingToolFilterValue.rawMaterialGrade![x];
      _item.text = this.costingToolFilterValue.rawMaterialGrade![x];
      this.rmGradeOptionList.push(_item);
    }

    // Alloy
    this.alloyOptionList = new Array();
    _item = new SelectOption();
    _item.text = 'Yes';
    _item.value = true;
    this.alloyOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'No';
    _item.value = false;
    this.alloyOptionList.push(_item);

    // Process
    this.processOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.processOptionList.push(_item);
    for (var x = 0; x < this.costingToolFilterValue.process!.length; x++) {
      _item = new SelectOption();
      _item.value = this.costingToolFilterValue.process![x];
      _item.text = this.costingToolFilterValue.process![x];
      this.processOptionList.push(_item);
    }

    // UT
    this.utOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.utOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'Yes';
    _item.value = true;
    this.utOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'No';
    _item.value = false;
    this.utOptionList.push(_item);

    // Hydro
    this.hydroOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.hydroOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'Yes';
    _item.value = true;
    this.hydroOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'No';
    _item.value = false;
    this.hydroOptionList.push(_item);

    // U-Bend
    this.uBendOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.uBendOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'Yes';
    _item.value = true;
    this.uBendOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'No';
    _item.value = false;
    this.uBendOptionList.push(_item);

    // LG Type
    this.lgTypeOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.lgTypeOptionList.push(_item);
    for (var x = 0; x < this.costingToolFilterValue.lengthType!.length; x++) {
      _item = new SelectOption();
      _item.value = this.costingToolFilterValue.lengthType![x];
      _item.text = this.costingToolFilterValue.lengthType![x];
      this.lgTypeOptionList.push(_item);
    }

    // HT HOT
    this.htHotOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.htHotOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'Yes';
    _item.value = true;
    this.htHotOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'No';
    _item.value = false;
    this.htHotOptionList.push(_item);

    // HT COLD
    this.htColdOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.htColdOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'Yes';
    _item.value = true;
    this.htColdOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'No';
    _item.value = false;
    this.htColdOptionList.push(_item);

    // HT ADD
    this.htAddOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.htAddOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'Yes';
    _item.value = true;
    this.htAddOptionList.push(_item);
    _item = new SelectOption();
    _item.text = 'No';
    _item.value = false;
    this.htAddOptionList.push(_item);

    // Plant
    this.plantOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.plantOptionList.push(_item);
    for (var x = 0; x < this.costingToolFilterValue.plant!.length; x++) {
      _item = new SelectOption();
      _item.value = this.costingToolFilterValue.plant![x];
      _item.text = this.costingToolFilterValue.plant![x];
      this.plantOptionList.push(_item);
    }
    // Ends Condition
    this.endsConditionOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.endsConditionOptionList.push(_item);
    for (var x = 0; x < this.costingToolFilterValue.endsCondition!.length; x++) {
      _item = new SelectOption();
      _item.value = this.costingToolFilterValue.endsCondition![x];
      _item.text = this.costingToolFilterValue.endsCondition![x];
      this.endsConditionOptionList.push(_item);
    }
    // Test Condition
    this.testConditionOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.testConditionOptionList.push(_item);
    for (var x = 0; x < this.costingToolFilterValue.testCondition!.length; x++) {
      _item = new SelectOption();
      _item.value = this.costingToolFilterValue.testCondition![x];
      _item.text = this.costingToolFilterValue.testCondition![x];
      this.testConditionOptionList.push(_item);
    }

    // SQL
    this.sqlOptionList = new Array();
    _item = new SelectOption();
    _item.text = '';
    _item.value = null;
    this.sqlOptionList.push(_item);
    const sqlValues: string[] = (this.costingToolFilterValue.sql || []);
    for (var x = 0; x < sqlValues.length; x++) {
      _item = new SelectOption();
      _item.value = sqlValues[x];
      _item.text = sqlValues[x];
      this.sqlOptionList.push(_item);
    }


    this.filtersOptionReady = true;
  }

  getCostingToolRecords(shoLoader: boolean) {

    if(!this.rawMaterialGrade){
      return;
    }

    this.teiasoftLoader.start();
    this.asIncluded = true;
    this.roundNumericFilters();
    this.beService.getCostingToolRecords(this.rawMaterialGrade!, true, this.od!, this.wt!, this.id!, this.process!, this.ut!, this.hydro!, this.lengthType!,
      this.htHot!, this.htCold!, this.htAdd!, this.versionId!, this.lengthMin!, this.lengthMax!, this.uBent!, this.plant!, this.endsCondition!, this.testCondition!, this.sql!,
      this.unitSystem!, this.currency!).subscribe(res => {
        this.teiasoftLoader.stop();
        this.resultDataset = res.exactMatches || [];
        this.processResultData(res);
      });
  }

  private roundNumericFilters(): void {
    this.od = this.toRoundedNumberOrNull(this.od, 'od');
    this.wt = this.toRoundedNumberOrNull(this.wt, 'wt');
    this.id = this.toRoundedNumberOrNull(this.id, 'id');
    this.lengthMin = this.toRoundedNumberOrNull(this.lengthMin, 'lengthMin');

    if (this.lengthType === 'FL') {
      this.lengthMax = this.lengthMin;
    } else {
      this.lengthMax = this.toRoundedNumberOrNull(this.lengthMax, 'lengthMax');
    }
  }

  private toRoundedNumberOrNull(value: any, fieldName: string): number | null {
    if (value == null || value == undefined || value === '') return null;

    const normalizedValue = parseFloat(value.toString().replace(',', '.'));
    if (!isFinite(normalizedValue)) return null;

    return Number.parseFloat(normalizedValue.toFixed(this.getRoundDigits(fieldName)));
  }

  getRoundDigits(col: string): number {
    if (!this.roundDigitsForItemForm || this.roundDigitsForItemForm.length == 0) return 2;

    const roundDigit = this.roundDigitsForItemForm.find(x => x.fieldName?.toLowerCase() == col.toLowerCase());
    if (!roundDigit) return 2;

    const unitSystem = (this.unitSystem ?? '').toString().toLowerCase();
    if (unitSystem == 'metric') return roundDigit.metricDigits ?? 2;
    if (unitSystem == 'imperial') return roundDigit.imperialDigits ?? 2;

    return 2;
  }

  getCostingToolRecordsById() {
    this.teiasoftLoader.start();
    this.beService.getCostingToolRecordsById(this.costsSourceCostingToolRecordId!, this.versionId!, this.unitSystem, this.currency).subscribe(res => {
      this.teiasoftLoader.stop();
      this.resultDataset = res.exactMatches || [];
      this.processResultData(res);
    });
  }

  processResultData(res: CostingToolRecordsResponse) {
    // Add Summary and Calculate Yield

    // Ref. material: {materialNr} - {rawMaterialGrade} 
    // - OD WT - {od} x {wt} - HT Proc.: {IF process == 'hot' THEN htHot ELSE htCold} - HT Add.: {htAdd} 
    // - US test: {ut} - Hydro: {hydro} 
    // - LG type: {lengthType} {IF lengthType == 'RL' THEN {lengthMin} / {lengthMax} ELSE {lengthMin}} - Ends: {endsCondition} - SQL: {specQualLevel}"

    this.resultDataset = res.exactMatches || [];
    for (const result of this.resultDataset) {
      this.enrichCostingToolRecord(result);
    }


    const customIndex = this.resultDataset.findIndex(item => item && item.isExternalCr === true);
    if (customIndex >= 0) {
      const customItem = this.resultDataset[customIndex];
      const cleanedCustomItem: any = {};

      Object.keys(customItem).forEach(k => {
        if (k === "asIncluded" || k === "fullCostPerWeight" || k === "fullCostPerLength" || k === 'fullCostPerWeightUom' || k === 'fullCostPerLengthUom') {
          cleanedCustomItem[k] = customItem[k];
        } else {
          cleanedCustomItem[k] = null;
        }
      });

      cleanedCustomItem["summary"] = '';
      this.resultDataset[customIndex] = cleanedCustomItem;
    }

    this.nearestDataset = res.nearestMatches || [];



    if (this.nearestDataset && this.nearestDataset.length > 0) {
      for (let y = 0; y < this.nearestDataset.length; y++) {
        if (this.nearestDataset[y].materialNr === "CUSTOM") {
          this.nearestDataset[y].summary = this.translate.instant("costingTool.refMaterial") + ": " + this.nearestDataset[y].materialNr;
          continue;
        }

        this.enrichCostingToolRecord(this.nearestDataset[y]);
      }
    }
    this.isSubmit = true;
  }

  private enrichCostingToolRecord(record: CostingToolRecord): void {
    const process = record.process;
    const htProc = process == 'Hot' ? record.htHot : record.htCold;
    const lt = record.lengthType;
    const lgType = lt == 'RL' ? (record.lengthMin + "/" + record.lengthMax) : record.lengthMin;
    const dimensionsLabel = this.getDimensionsLabel(record);
    const hasToleranceType = record.typeOfTolerance != null && record.typeOfTolerance.toString().trim() != '';
    const toleranceTypeSuffix = hasToleranceType ? " - Tol. Type: " + record.typeOfTolerance : "";

    record.summary = this.translate.instant("costingTool.refMaterial") + ": " + record.materialNr + " - " + record.rawMaterialGrade +
      " - " + dimensionsLabel + " - HT Proc.: " + htProc + " - HT Add.: " + record.htAdd +
      " - US test: " + this.getBooleanLabel(record.ut) + " - Hydro: " + this.getBooleanLabel(record.hydro) +
      " - LG type: " + lt + " " + lgType + " " + (record.lengthUom ?? '') + " - Ends: " + record.endsCondition + " - SQL: " + record.specQualLevel +
      " - Bend: " + this.getBooleanLabel(record.bending) + " - Test Cond.: " + record.testCondition + toleranceTypeSuffix;

    if (record.yield != null && record.hollowYield != null) {
      // yield * hollowYield / 1000
      record.yield = (record.yield * record.hollowYield) / 1000;
    }
  }

  getMeasureFilterLabel(key: string): string {
    const label = this.translate.instant(key);
    const baseLabel = (label || '').replace(/\s*\([^)]*\)\s*$/, '').trim();
    const uom = this.getDefaultMeasureUom(key);
    return uom ? `${baseLabel} (${uom})` : baseLabel;
  }

  private getDefaultMeasureUom(key: string): string {
    const measure = key.toLowerCase().includes('length') ? 'length' :
      key.toLowerCase().includes('averagewt') ? 'wt' :
        key.toLowerCase().endsWith('.wt') ? 'wt' :
          key.toLowerCase().endsWith('.id') ? 'id' : 'od';

    return this.getUoms(`${measure}Uoms`).find(uom => uom.isDefault)?.text || '';
  }

  private getUoms(uom: string): SelectOption[] {
    const uoms = (this.itemParameterValues as any)?.[uom] as UomsType | undefined;
    const source = (this.unitSystem ?? '').toString().toLowerCase() == 'metric' ? uoms?.metricUoms : uoms?.imperialUoms;
    return (source ?? []).map(item => {
      const option = new SelectOption();
      option.text = item.uomCode!;
      option.value = item.uomCode!;
      option.isDefault = item.isDefault;
      return option;
    }).sort((a, b) => (a.isDefault === b.isDefault ? 0 : a.isDefault ? -1 : 1));
  }

  getGridHeaderLabel(column: string): string {
    const baseLabel = this.translate.instant('grid.' + column.substring(0, 1).toUpperCase() + column.substring(1));
    const uomColumn = this.headerUomByColumn[column];
    const uom = this.getGridHeaderUom(uomColumn);
    return uom ? `${baseLabel} (${uom})` : baseLabel;
  }

  private getGridHeaderUom(uomColumn?: string): string {
    if (!uomColumn) return '';
    const record = [...(this.resultDataset ?? []), ...(this.nearestDataset ?? [])].find(item => !!(item as any)?.[uomColumn]);
    return (record as any)?.[uomColumn] ?? '';
  }

  private getDimensionsLabel(record: CostingToolRecord): string {
    const dimType = this.resolveCostingToolDimType(record);
    if (dimType == 'IdWt') {
      return "ID WT - " + record.insideDiameter + " x " + record.wt;
    }

    if (dimType == 'OdId') {
      return "OD ID - " + record.od + " x " + record.insideDiameter;
    }

    return "OD WT - " + record.od + " x " + record.wt;
  }

  private resolveCostingToolDimType(record: CostingToolRecord): CostingToolDimType {
    const normalized = (record.dimType || '').toString().replace(/[_\s-]/g, '').toLowerCase();
    if (normalized == 'idwt') {
      return 'IdWt';
    }

    if (normalized == 'odid') {
      return 'OdId';
    }

    if (normalized == 'odwt') {
      return 'OdWt';
    }

    // Legacy fallback for payloads without dimType
    if (record.od == null && record.insideDiameter != null && record.wt != null) {
      return 'IdWt';
    }

    if (record.od != null && record.insideDiameter != null && record.wt == null) {
      return 'OdId';
    }

    return 'OdWt';
  }

  getBooleanLabel(value: boolean | null | undefined): string {
    return value === true ? this.translate.instant('noTranslations.yes') : this.translate.instant('noTranslations.no');
  }

  backToOrigin() {
    if (this.inpuItem) {
      this.onBackClick.emit();
    }
    else {
      this.router.navigate(["/enquiry-book"], { queryParams: { enquiryNo: this.enquiryNo, isExpand: this.origin == 'enquiry-book' } });
    }
  }

  setItemCostByCostingTool() {
    this.teiasoftLoader.start();
    this.beService.setItemCostByCostingTool(this.enquiryNo, this.itemNo, this.selectedCostingToolId).subscribe(res => {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.backToOrigin();
    });
  }

  /* EVENTS */
  onBtnToolbarClick(btn: TTButton) {
    if (btn.action == 'addAttitional') {
      $('.row-additional').fadeIn(250);
      this.showAdditionalSelections = true;
      this.buttonsList[0].action = "closeAdditional";
      this.buttonsList[0].tooltip = "closeAdditional";
      this.buttonsList[0].icon = "fal fa-angle-up";
      return;
    }

    if (btn.action == 'closeAdditional') {
      $('.row-additional').fadeOut(250);
      this.showAdditionalSelections = false;
      this.buttonsList[0].action = "addAttitional";
      this.buttonsList[0].tooltip = "addAttitional";
      this.buttonsList[0].icon = "fal fa-angle-down";
      return;
    }

    if (btn.action == 'clearFilter') {
      this.clearValue = true;
      setTimeout(() => {
        this.clearValue = false;
      }, 250);

      this.buttonsList[2].disabled = true;
      this.resultDataset = new Array();
      this.nearestDataset = new Array();

      if (this.origin == 'edit-enquiry') {
        this.rawMaterialGrade = null;
        this.asIncluded = true;
        this.od = null;
        this.wt = null;
        this.id = null;
        this.insideDiameter = null;
        this.process = null;
        this.ut = null;
        this.hydro = null;
        this.lengthType = null;
        this.htHot = null;
        this.htCold = null;
        this.htAdd = null;
        this.plant = null;
        this.endsCondition = null;
        this.testCondition = null;
        this.lengthMin = null;
        this.lengthMax = null;
        this.uBent = null;
        this.sql = null;
        this.unitSystem = this.inputUnitSystem ?? this.unitSystem;
        this.currency = this.inputCurrency ?? this.currency;
        this.isSubmit = false;

      }
      else {
        this.rawMaterialGrade = null;
        this.asIncluded = true;
        this.od = null;
        this.wt = null;
        this.id = null;
        this.insideDiameter = null;
        this.process = null;
        this.ut = null;
        this.hydro = null;
        this.lengthType = null;
        this.htHot = null;
        this.htCold = null;
        this.htAdd = null;
        this.plant = null;
        this.endsCondition = null;
        this.testCondition = null;
        this.lengthMin = null;
        this.lengthMax = null;
        this.uBent = null;
        this.sql = null;
        this.getUnitSystemAndCurrencyByUser();
        this.isSubmit = false;
        this.enquiryNo = '';
        this.itemNo = '';
        this.origin = '';

        this.router.navigate([], { queryParams: {} });  // MQF-640
      }




    }

    if (btn.action == 'submit') {
      setTimeout(() => {
        this.getCostingToolRecords(true);
      }, 450); // this was added due to the teiasoft-select component that need 200ms to handle the focus out 
    }

    if (btn.action == 'back') {
      this.backToOrigin();
    }
  }

  customIconClickResult(evt: any) {
    const _obj: any = parseGridActionEvent(evt).row;
    this.selectedCostingToolId = _obj["id"];
    this.setItemCostByCostingTool();
    // this.teiasoftModalService.show("confirm", "CostingTool", this.translate.instant('costingTool.confirmSelectCost'), '', 'confirmSelectCost');
  }

  customIconClickNearest(evt: any) {
    const _obj: any = parseGridActionEvent(evt).row;
    this.selectedCostingToolId = _obj["id"];
    this.setItemCostByCostingTool();
    // this.teiasoftModalService.show("confirm", "CostingTool", this.translate.instant('costingTool.confirmSelectCost'), '', 'confirmSelectCost');
  }

  onConfirmModal(evt: TeiasoftModalReturnObject) {
    if (evt.closeFlag == 'confirmSelectCost') {
      this.setItemCostByCostingTool();
    }
  }

  enableSubmit() {
    let _disabled: boolean = true;
    if (this.rawMaterialGrade != null && this.asIncluded != null && this.atLeastTwoNotNull(this.od, this.wt, this.id)) {
      _disabled = false;
    }

    this.buttonsList[2].disabled = _disabled;
  }

  atLeastTwoNotNull(a: any, b: any, c: any): boolean {
    let notNullCount = 0;

    if (a !== null && a !== '') {
      notNullCount++;
    }

    if (b !== null && b !== '') {
      notNullCount++;
    }

    if (c !== null && c !== '') {
      notNullCount++;
    }

    return notNullCount >= 2;
  }

  isOlderVersionSelected(): boolean {
    if (!this.selectedVersionId) return false;
    const selectedVersion = this.masterDataVersions.find(x => x.id == this.selectedVersionId);
    return selectedVersion ? selectedVersion.isCurrent != true : false;
  }

  onSelectedVersion(evt: SelectOption) {
    this.selectedVersionId = evt.value;
    if (this.masterDataVersions.filter(x => x.id == evt.value)[0].isCurrent == true)
      this.versionId = null;
    else
      this.versionId = this.selectedVersionId;
  }

  onSelectedUnitSystem(evt: SelectOption) {
    this.unitSystem = evt.value;
  }

  onSelectedCurrency(evt: SelectOption) {
    this.currency = evt.value;
  }

  //#region FilterEvents
  onSelectedRm(evt: SelectOption) {
    this.rawMaterialGrade = evt.value;
    this.enableSubmit();
  }

  onSelectedAS(evt: SelectOption) {
    this.asIncluded = evt.value;
    this.enableSubmit();
  }

  onInputOd(evt: any) {
    if (evt != '')
      this.od = evt;
    else
      this.od = null;

    this.enableSubmit();
  }

  onInputWt(evt: any) {
    if (evt != '')
      this.wt = evt;
    else
      this.wt = null;

    this.enableSubmit();
  }

  onInputId(evt: any) {
    if (evt != '')
      this.id = evt;
    else
      this.id = null;

    this.enableSubmit();
  }

  onSelectedProcess(evt: SelectOption) {
    this.process = evt.value;
  }

  onSelectedUt(evt: SelectOption) {
    this.ut = evt.value;
  }

  onSelectedHydro(evt: SelectOption) {
    this.hydro = evt.value;
  }

  onSelectedLgType(evt: SelectOption) {
    this.lengthType = evt.value;
    if (this.lengthType === 'FL') {
      this.lengthMax = this.lengthMin;
    }
    if (evt.value == null) {
      this.lengthMin = null;
      this.lengthMax = null;
    }
  }

  onSelectedHtHot(evt: SelectOption) {
    this.htHot = evt.value;
  }

  onSelectedHtCold(evt: SelectOption) {
    this.htCold = evt.value;
  }

  onSelectedHtAdd(evt: SelectOption) {
    this.htAdd = evt.value;
  }

  onSelectedPlant(evt: SelectOption) {
    this.plant = evt.value;
  }

  onSelectedEndsCondition(evt: SelectOption) {
    this.endsCondition = evt.value;
  }

  onSelectedTestCondition(evt: SelectOption) {
    this.testCondition = evt.value;
  }

  onInputLengthMin(evt: any) {
    if (evt != '')
      this.lengthMin = evt;
    else
      this.lengthMin = null;

    if (this.lengthType === 'FL') {
      this.lengthMax = this.lengthMin;
    }
  }

  onInputLengthMax(evt: any) {
    if (this.lengthType === 'FL') {
      this.lengthMax = this.lengthMin;
      return;
    }

    if (evt != '')
      this.lengthMax = evt;
    else
      this.lengthMax = null;
  }

  onSelectedUBend(evt: SelectOption) {
    this.uBent = evt.value;
  }

  onSelectedSql(evt: SelectOption) {
    this.sql = evt.value;
  }
  //#endregion
}
